import { combineReducers } from 'redux';
import locations from './locations';

export default combineReducers({
  locations,
});
